import Vue from 'vue'
import Vuex from 'vuex'
import {
  storageUser,
  storageClinic,
  storageBranch
} from '@/plugins/VuexPersist'

import UserModule from './user'
import LoadingModule from './loading'
import AppModule from './app'
import ClinicModule from './clinic'
import BranchModule from './branch'
import ThemeModule from './theme'
import CreditModule from './credit'

Vue.use(Vuex)

const store = new Vuex.Store({
  // state: {
  // },
  // getters: {
  // },
  // mutations: {
  // },
  // actions: {
  // },
  modules: {
    User: UserModule,
    Loading: LoadingModule,
    App: AppModule,
    Clinic: ClinicModule,
    Branch: BranchModule,
    Theme: ThemeModule,
    Credit: CreditModule
  },
  plugins: [
    storageUser.plugin,
    storageClinic.plugin,
    storageBranch.plugin
  ]
})

export default store
